<template>
  <nav-bar title="返瓶记录详细" />
  <Content :bottom="showSubmit ? 76 : 0">
    <Loading
      v-if="showLoading"
      :isLoading="isLoading"
      @reload="getDataLoading"
    />
    <customer-info />
    <van-cell-group class="group" :title="orderBase.placeDate" >
      <van-cell v-for="item in infoList" :key="item.id" :title="item.goodsName" :value="`${item.goodsCount}瓶`" />
    </van-cell-group>
  </Content>
  <div v-if="showSubmit" class="btn-conatiner van-hairline--top">
    <van-button block type="primary" native-type="button" :loading="loading" :disabled="loading" @click="handleSubmit">
      返瓶确认
    </van-button>
  </div>
</template>

<script>
import { returnOrderInfo, userReceiveCylinder } from '@/api/order'
import { useGetDataLoading } from '@/hooks/useGetDataLoading'
import { useSubmit, loading } from '@/hooks/useSubmit'
import { reactive, toRefs, computed } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
export default {
  name: 'BottleReturnRecordDetail', // 返瓶记录详细
  props: ['orderId'],
  setup (props) {
    // 记录详细
    const detail = reactive({
      infoList: [],
      orderBase: {}
    })
    const { getDataLoading, showLoading, isLoading } = useGetDataLoading(returnOrderInfo, (data) => {
      for (const key in detail) {
        detail[key] = data[key]
      }
    }, props.orderId)
    getDataLoading()

    // 返瓶确认
    const router = useRouter()
    const store = useStore()
    const userId = computed(() => store.state.customer.userId)

    const handleSubmit = () => {
      const params = {
        orderId: props.orderId,
        userId: userId.value
      }
      const { onSubmit } = useSubmit(userReceiveCylinder, params, () => {
        router.back()
      })
      onSubmit()
    }

    const showSubmit = computed(() => (!showLoading.value && detail.orderBase.orderStatus === '02'))
    return {
      getDataLoading,
      showLoading,
      isLoading,
      ...toRefs(detail),
      handleSubmit,
      loading,
      showSubmit
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-conatiner {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px;
}
</style>
